import React from 'react';
import { GlareCard } from "@/components/ui/glare-card";
import { Target, Clock, Wand2, Sparkles, MapPin, Laptop } from 'lucide-react';

const Features = () => {
  return (
    <section id="features" className="hidden md:block py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Why Choose Njord?</h2>
          <div className="w-24 h-1 bg-primary mx-auto"></div>
        </div>

        <div className="flex flex-wrap justify-center gap-8">
          <GlareCard className="flex flex-col items-center justify-center !w-[280px] !aspect-square">
            <Target className="h-14 w-14 text-white mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Built for Results</h3>
            <p className="text-neutral-200 text-center px-4">
              Every bot is engineered to convert, qualify, or save time — not just look good.
            </p>
          </GlareCard>
          
          <GlareCard className="flex flex-col items-center justify-center !w-[280px] !aspect-square">
            <Clock className="h-14 w-14 text-white mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Time-Saving Automation</h3>
            <p className="text-neutral-200 text-center px-4">
              Automate repetitive tasks, reduce admin time, and stay available 24/7 without lifting a finger.
            </p>
          </GlareCard>
          
          <GlareCard className="flex flex-col items-center justify-center !w-[280px] !aspect-square">
            <Wand2 className="h-14 w-14 text-white mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Fully Tailored Systems</h3>
            <p className="text-neutral-200 text-center px-4">
              We design every automation around your operations, not generic templates.
            </p>
          </GlareCard>

          <GlareCard className="flex flex-col items-center justify-center !w-[280px] !aspect-square">
            <Sparkles className="h-14 w-14 text-white mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Sleek, Professional Delivery</h3>
            <p className="text-neutral-200 text-center px-4">
              Clean builds, fast performance, and on-brand design that makes you look sharp.
            </p>
          </GlareCard>

          <GlareCard className="flex flex-col items-center justify-center !w-[280px] !aspect-square">
            <MapPin className="h-14 w-14 text-white mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Transparent & UK-Based</h3>
            <p className="text-neutral-200 text-center px-4">
              No overseas handoffs — we're based in Corby and work directly with every client.
            </p>
          </GlareCard>

          <GlareCard className="flex flex-col items-center justify-center !w-[280px] !aspect-square">
            <Laptop className="h-14 w-14 text-white mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Future-Proof Tech</h3>
            <p className="text-neutral-200 text-center px-4">
              We constantly circulate on the latest AI tools and keep our service at the top
            </p>
          </GlareCard>
        </div>
      </div>
    </section>
  );
};

export default Features;